import * as shared from "@/styles/shared";
import { useBankSettings } from "@shared/contexts";
import { BANK_TYPE_OPTIONS, getBankLabel } from "@shared/types/settings";
import type { BankType } from "@shared/types/settings";
import { Building2, CreditCard, Lock, User } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import * as styles from "../../pages/SettingsPage.styles";

const AddBankForm = () => {
  const [saving, setSaving] = useState(false);
  const { t } = useTranslation("settings");
  const { addForm, patchAddForm, handleAddBank, cancelAdding } = useBankSettings();

  return (
    <div className={styles.addForm}>
      <div className={styles.inputWrapper}>
        <Building2 className={shared.inputIcon} />
        <input
          type="text"
          name="bank-name"
          value={addForm.name}
          onChange={(e) => patchAddForm({ name: e.target.value })}
          placeholder={t("bankNamePlaceholder")}
          autoComplete="off"
          className={`${styles.input} ${styles.inputIconPadding}`}
        />
      </div>

      <div className={styles.inputWrapper}>
        <CreditCard className={shared.inputIcon} />
        <select
          value={addForm.type}
          onChange={(e) => patchAddForm({ type: e.target.value as BankType })}
          className={`${styles.select} ${styles.inputIconPadding}`}
        >
          {BANK_TYPE_OPTIONS.map((type) => (
            <option key={type} value={type}>
              {getBankLabel(type)}
            </option>
          ))}
        </select>
      </div>

      <div className={styles.inputWrapper}>
        <User className={shared.inputIcon} />
        <input
          type="text"
          name="bank-username"
          value={addForm.username}
          onChange={(e) => patchAddForm({ username: e.target.value })}
          placeholder={t("usernamePlaceholder")}
          autoComplete="off"
          className={`${styles.input} ${styles.inputIconPadding}`}
        />
      </div>

      <div className={styles.inputWrapper}>
        <Lock className={shared.inputIcon} />
        <input
          type="password"
          name="bank-password"
          value={addForm.password}
          onChange={(e) => patchAddForm({ password: e.target.value })}
          placeholder={t("passwordPlaceholder")}
          autoComplete="new-password"
          className={`${styles.input} ${styles.inputIconPadding}`}
        />
      </div>

      <div className={styles.formActions}>
        <button
          onClick={() => {
            setSaving(true);
            handleAddBank().finally(() => setSaving(false));
          }}
          disabled={saving || !addForm.name.trim()}
          className={styles.saveButton}
        >
          {saving ? t("saving") : t("create")}
        </button>
        <button onClick={cancelAdding} className={styles.cancelButton}>
          {t("cancel")}
        </button>
      </div>
    </div>
  );
};

export { AddBankForm };
